import RequestInfoSection from './newAegRequest/sections/RequestInfoSection';
import RequesterSection from './newAegRequest/sections/RequesterSection';
import VehicleCustomerSection from './newAegRequest/sections/VehicleCustomerSection';
import RepairSection from './newAegRequest/sections/RepairSection';
import AttachmentsSection from './newAegRequest/sections/AttachmentsSection';
import ForwardingSection from './newAegRequest/sections/ForwardingSection';
import VehicleDataAside from './newAegRequest/VehicleDataAside';
import { AegRequestFormBodyProps } from '../../../../models/newAEG';

const AegRequestFormBody = ({ vehicle, isLoadingVehicle, ...props }: AegRequestFormBodyProps) => (
    <div className='grid grid-cols-[minmax(0,1fr)] lg:grid-cols-[minmax(0,1fr)_340px] gap-4 items-start'>
        <div className='display-flex flex-column gap-y-3 min-w-0'>
            <RequestInfoSection {...props} />
            <RequesterSection {...props} />
            <VehicleCustomerSection {...props} />
            <RepairSection {...props} />
            <AttachmentsSection {...props} />
            <ForwardingSection {...props} />
        </div>
        <aside className='lg:sticky lg:top-[10px] lg:h-[calc(100vh-131px)] min-w-0'>
            <VehicleDataAside vehicle={vehicle} isLoading={isLoadingVehicle} />
        </aside>
    </div>
);

export default AegRequestFormBody;
